import { appointment } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useAddAppointmentNote = (appointmentId, onSuccess = () => {}) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: appointment.createNote,
    onSuccess: () => {
      queryClient.invalidateQueries(['appointment', appointmentId])
			onSuccess()
    },
  })

	return mutation
}